import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initGlobalErrorHandlers } from "@/lib/globalErrorHandler";
import { initPerformanceObserver } from "@/lib/perf";

// Initialize enterprise-level monitoring before rendering
initGlobalErrorHandlers();
initPerformanceObserver();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
